import React, { useEffect, useState } from 'react';
import Loader from '@lwt-helix/loader';
import { TodaysPicksCard } from './TodaysPicksCard';
import { getTodaysPicks } from '../../../../service/proficiency-metrics';
import { todaysPicksTerms } from '../../../constants/suggestedAgents';

export const TodaysPicks = () => {
    const [agents, setAgents] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setIsLoading(true);
        getTodaysPicks()
            .then(({ error, results }) => {
                error ? setError(error) : setAgents(results || []);
            })
            .catch(err => setError(err.message))
            .finally(() => setIsLoading(false));
    }, []);

    const renderCenteredMessage = (title, body, isLoading) => (
        <div className="helix-d-flex helix-justify--center helix-align--center helix-py-5">
            {isLoading ? <Loader /> : <div className="helix-text--center">
                <h5 className="helix-text-gray-900">{title}</h5>
                {body && <p className="helix-text-gray-500">{body}</p>}
            </div>}
        </div>
    );
    if (isLoading) {
        return renderCenteredMessage(null, null, true);
    }
    if (!agents.length) {
        return renderCenteredMessage(
            todaysPicksTerms.noTodaysPicksTitle,
            todaysPicksTerms.noTodaysPicksBody
        );
    }

    //TODO: Add if needed after further discussion
    if (error) {
        return renderCenteredMessage(todaysPicksTerms.failedLoad, error);
    }

    return (
        <div className="helix-pt-3">
            <div className="todays-picks-grid">
                {agents.map((agent) => (
                    <TodaysPicksCard key={agent.agentId} agent={agent} />
                ))}
            </div>
        </div>
    );
};

export default TodaysPicks;
